// @flow

import * as React from 'react';

import type { DecoratedProduct } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

import ErrorRow from './Rows/ErrorRow';
import TitleRow from './Rows/TitleRow';

import { useRemoveProductHandler } from './modules';

import styles from './ProductItemBase.scss';

type Props = {
  children: React.Node,
  footer: React.Node,
  header: React.Node,
};

export default function ProductItemBase({
  children,
  footer,
  header,
}: Props): React.MixedElement {
  return (
    <>
      <Base tagName="li" flex flexCol className={styles.item}>
        {header}
        <Base flex gap="spacing-1x" flexCol className={styles.child}>
          {children}
        </Base>
        {footer}
      </Base>
      <hr />
    </>
  );
}

ProductItemBase.Error = function ProductItemBaseError({
  product,
}: {
  product: void | DecoratedProduct,
}): React.MixedElement {
  const { __ } = useTranslator();
  const removeProduct = useRemoveProductHandler(product?.id);

  const title = product
    ? product.label || product.fqdn || product.identifier
    : __('Error');

  return (
    <>
      <Base tagName="li" flex flexCol className={styles.item}>
        <TitleRow.Error label={title} productType={product?.productType} />
        <ErrorRow handleRemoveAction={removeProduct} errors={product?.errors} />
      </Base>
      <hr />
    </>
  );
};
